import { Button } from "@mui/material"
import { Edit } from "@mui/icons-material"
import React from "react"
import { AddEditComponent } from "../../GenericList"
import { PopupService } from "react-ui-components/components/PopupService"
import { configData } from "./businesses-config"

/**
 * Props for the BusinessDetailInfo component
 */
interface BusinessDetailInfoProps {
  id: string
  data: any
  reload: () => void
}

/**
 * Component for displaying detailed information about a business
 * Shows business data in a two-column layout with edit functionality
 */
export function BusinessDetailInfo({ id, data, reload }: BusinessDetailInfoProps) {
  return (
    <div>
      <div className="flex flex-row gap-6 align-center">
        <h1>Business Detail</h1>
        <Button
          onClick={() => {
            PopupService.setPopup(
              <AddEditComponent
                Service={configData}
                mainId={id}
                data={data}
                onAdded={() => {
                  reload && reload()
                }}
              />,
            )
          }}
        >
          <Edit />
        </Button>
      </div>
      <div className="flex flex-col flex-wrap gap-3 border-solid border-2 border-sky-500  w-fit">
        {!!data && (
          <div className="flex flex-row gap-4">
            <div>
              {Object.keys(data)
                .slice(0, Math.ceil(Object.keys(data).length / 2))
                .map((item) => (
                  <div key={item} className="flex flex-row flex-wrap gap-3 m-2">
                    <h1 className="capitalize w-fit">
                      {item}
                      {": "}
                    </h1>
                    <h6 className="flex flex-wrap max-w-60 break-all">
                      {JSON.stringify(data[item.trim()])}
                    </h6>
                  </div>
                ))}
            </div>

            <div>
              {Object.keys(data)
                .slice(Math.ceil(Object.keys(data).length / 2))
                .map((item) => (
                  <div key={item} className="flex flex-row flex-wrap gap-3 m-2">
                    <h1 className="capitalize w-fit">
                      {item}
                      {": "}
                    </h1>
                    <h6 className="flex flex-wrap max-w-60 break-all">
                      {JSON.stringify(data[item.trim()])}
                    </h6>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}